<template>
  <div class="header py-1 bg-black-1 mb-5 hide-for-print relative">
    <!-- 头部图片 -->
    <div class="header-imgs relative" :style="styleHeightObj">
      <div ref="" class="container w-full h360 overflow-hidden"></div>
      <div ref="" class="container2 absolute top-0 left-0 px-10 py-4 w-full flex justify-between">
        <img v-for="item in headerImgs" :key="item.id" :src="item.src" alt=""
          style="width: 300px; height: 300px; cursor: pointer" @click="headerSign = item.id" />
      </div>
    </div>
    <!-- 自定义页面入口 -->
    <img v-if="headerImgFlag" :src="currentHeaderImg" @mouseenter="mouseFlag = true" @mouseleave="mouseFlag = false"
      @click="router.push({ path: '/home' })" class="custom-entry-img w145 h145 cursor-pointer"
      :class="ynHeaderImgFlag ? 'fixed-position' : 'absolute left-0'" />
    <div class="relative h-full">
      <!-- 打印列表 -->
      <div class="h-8 my-1 none flex justify-center items-center" :class="shoppingCartShow ? 'yesanmite' : 'noanmite'" v-loading="isLoading">
        <StandardButton class="relative z-30 rounded-md !h-8 w-[120px]" :class="shoppingCartShow
          ? 'bg-white border border-[#E6E8FF]'
          : localHadrDiskSize > 0 ? 'bg-[#F3F4F9]' : 'bg-[#FFFFFF0F]'
          " @click="goConfirmOrder">
          <!-- 容量条显示 -->
          <div class="absolute z-10 left-0 top-0 h-full rounded-md bg-[#C9CAD6] max-w-[120px] overflow-hidden"
            :style="{ width: `${hardDiskSize / 5}%` }"></div>
          <div
            class="tracking-widest flex-col absolute z-20 left-0 top-0 w-full h-full rounded-md flex items-center justify-center"
            :class="localHadrDiskSize > 0 ? 'text-[#222226]' : shoppingCartShow ? 'text-[#222226]' : 'text-white'">
            <div class="text-sm">打印列表</div>
            <div v-if="hardDiskSize > 0" class="flex items-center text-[10px] h-3 tracking-tight"
              :class="localHadrDiskSize > 0 ? 'text-[#222226]' : shoppingCartShow ? 'text-[#222226]' : 'text-white'">
              <span class="">上传容量:</span>
              <span class="">{{ hardDiskSize }}/500MB</span>
            </div>
          </div>
        </StandardButton>
        <!-- 购物车下拉面板：独立于「打印列表」按钮之外，避免点击冒泡触发结算跳转 -->
        <!-- 面板内只有商品图片可点击，其余区域（总计/价格/空白）不触发任何跳转 -->
        <div v-if="shoppingCartShow"
          class="w-[140px] bg-white rounded-b-lg shadow-lg absolute z-30 left-[calc(50%_-_70px)] top-[60px]">
          <div class="flex items-center px-5 ">
            <span class="text-[#000] text-xs font-bold mr-3">总计</span>
            <span class="text-[#F74417] text-xs font-bold">￥{{ shoppingCartListTotal.toFixed(2) }}</span>
          </div>
          <div class="overflow-y-auto max-h-[calc(100vh-76px)] px-2.5 pb-5">
            <div v-for="item in shoppingCartList" :key="item.id" class="mt-2.5" v-loading="isLoading">
              <img class="w-[120px] h-[120px] object-cover rounded-md mx-auto cursor-pointer"
                @click="goProductDetail(item)" :src="item.img" />
              <div class="flex justify-between items-center mt-3">
                <span class="text-[#F74417] text-[14px] text-base">￥{{ item.price.toFixed(2) }}</span>
              </div>
              <div class="flex justify-between items-center mt-3">
                <StandardInputNumber :modelValue="item.num" :item="item" @updateNum="updateNumChange"
                  :setting="{ min: 1, max: 99 }" @click.stop :controlsPosition="false"
                  class="w-20 h-8 border border-[#47496F] rounded" />
                <button @click.stop="delGood(item)" class="w-8 h-8 rounded hover:bg-black-1 bg-black-1/50">
                  <img class="m-auto w-3 h-3" src="@assets/images/Icon_del.png" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-text h-10 flex bg-black-1 justify-between">
      <div class="pl-7 h-8 my-1 flex items-center">
        <router-link to="/">
          <img src="../../assets/images/logo01.png" style="width: 100px;min-width: 100px;" />
        </router-link>
        <!-- 语言变化设置 -->
        <!-- <StandardButton
          class="text-white tracking-widest !min-w-[93px] bg-black-2"
        >
          {{ "中文" }}
        </StandardButton> -->
        <StandardButton
          class="text-white bg-black-2 ml-7 flex justify-center items-center relative w-auto min-w-[178px] max-w-[260px] text-sm"
          @click="!isLogin ? (loginShow = true) : (addressShow = true)">
          <!-- dizhi -->
          <div class="mr-2 text-left flex">
            <span class="ellipsis inline-block address-maxwidth">
              {{ selectedAddress.name || "收货地址" }}
            </span>
          </div>
          <AddressTagIcon :tagVal="selectedAddress.tagVal" :is-black="false" />
        </StandardButton>
      </div>
      <div class="h-8 my-1 w-full flex ml-6 rounded-md overflow-hidden bg-white" style="max-width: 1250px">
        <button class="h-full w-10 flex justify-center items-center rounded" style="background: #eaebf7"
          @click="goSearchPage">
          <svg t="1745633218198" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="5096" width="22" height="22">
            <path
              d="M441.192 181.831c132.48-13.704 255.824 68.524 292.371 191.868 4.568 18.274-4.568 27.41-13.704 18.274C660.471 277.764 555.4 209.24 441.193 227.513c-22.841 4.567-27.41-41.114 0-45.683z m324.347 511.648c-4.568-4.567 0-18.274 4.567-22.841 50.251-63.955 77.661-141.617 77.661-228.413 0-201.004-164.459-365.463-365.463-365.463-201.004 0-365.463 164.459-365.463 365.463 0 201.004 164.459 365.463 365.463 365.463 86.797 0 164.459-27.41 223.846-73.092 9.137-9.137 18.274-13.704 27.41-4.567l127.913 132.48c9.137 9.137 27.41 4.567 36.547-4.567 9.137-9.137 9.137-22.841 0-31.978l-132.48-132.48z m-283.232 73.092c-178.163 0-319.779-146.185-319.779-324.348s141.617-319.779 319.779-319.779c178.163 0 324.348 141.616 324.348 319.779 0 178.163-146.185 324.348-324.348 324.348z"
              p-id="5097" fill="#222226"></path>
          </svg>
        </button>
        <StandardInput v-model="searchStr" autocomplete="off" :maxlength="30" @keyup.enter="goSearchPage"
          placeholder="在 WidoFactory.com 中搜索" class="searchInput h-full rounded-none text-black"
          style="border-radius: 0px;border: none;" />
      </div>
      <!-- 站内信 -->
      <div class="relative" v-if="isLogin">
        <StandardButton class="bg-black-2 text-white relative tracking-widest w-[56px] ml-2.5 px-4 !h-8 mt-1"
          @click.stop="toggleNotifications">
          <svg t="1763371136792" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3485" width="24" height="24">
            <path
              d="M958.359001 286.941198c0-64.308655-52.132334-116.440989-116.440989-116.440989L181.453678 170.500209c-64.308655 0-116.440989 52.132334-116.440989 116.440989l0 448.63995c0 64.308655 52.132334 116.440989 116.440989 116.440989l660.464333 0c64.308655 0 116.440989-52.132334 116.440989-116.440989L958.359001 286.941198zM843.814198 212.455763c12.059664 0 23.444968 3.465938 33.519418 8.598842L530.749016 549.347606c-1.227967 1.161453-1.156336 0.916882-1.752924 1.868557-1.426489 1.067308-6.055926 3.922333-15.449877 3.922333-9.397021 0-14.025435-2.75474-15.4509-3.818979-0.676405-1.077541-0.662079-0.716314-1.995447-1.940189l-353.122503-324.412624c11.609409-7.557116 25.445532-12.509918 40.300868-12.509918L843.814198 212.456786zM916.403446 736.484727c0 40.857547-31.730679 73.582879-72.589248 73.582879L183.27721 810.067606c-40.85857 0-75.28566-32.725332-75.28566-73.582879L107.99155 287.657512c0-10.630105 2.860141-20.735253 6.909363-29.882588l351.486236 322.096882c4.91187 5.302773 19.479657 17.676591 47.009663 17.676591 27.799136 0 42.303478-12.618389 47.076178-17.830087l346.800517-328.899822c6.251378 10.860349 9.129938 23.433712 9.129938 36.838L916.403446 736.484727z"
              fill="#ffffff" p-id="3486"></path>
          </svg>
          <span v-if="unreadCount > 0"
            class="absolute top-0 right-0 w-auto p-1 min-w-[14px] h-[14px] bg-[#F74417] text-white  font-medium text-[10px] rounded-full flex items-center justify-center">{{
              unreadCount > 99 ? 99 : unreadCount }}</span>
        </StandardButton>
        <div v-show="isNotificationDropdown" :class="[
          'absolute z-30 -left-5 top-[50px]',
          secondaryVisible || aftersaleVisible ? 'w-[484px]' : 'w-[90px]',
        ]" @click.stop>
          <div class="flex">
            <div
              class="w-[90px] h-[120px] py-1.5 text-[10px] bg-white rounded-lg shadow-[0_0_20px_0_rgba(168,168,168,0.25)]">
              <ul>
                <li class="px-2.5 py-2 flex items-center justify-between cursor-pointer" :class="primaryCategory === 'comment'
                  ? 'text-[#000] font-bold bg-[#F3F4F9]'
                  : ''
                  " @click="choosePrimary('comment')">
                  <span class="text-sm">评论</span>
                  <span v-if="unreadCountByCategory('comment') > 0"
                    class="text-[10px] bg-[#F74417] text-white rounded-full p-1 min-w-[14px] h-[14px] flex items-center justify-center">{{
                      unreadCountByCategory("comment") > 99
                        ? 99
                        : unreadCountByCategory("comment")
                    }}</span>
                </li>
                <li class="px-2.5 py-2 flex items-center justify-between cursor-pointer" :class="primaryCategory === 'aftersale'
                  ? 'text-[#000] font-bold bg-[#F3F4F9]'
                  : ''
                  " @click="choosePrimary('aftersale')">
                  <span class="text-sm">售后</span>
                  <span v-if="unreadCountByCategory('aftersale') > 0"
                    class="text-[10px] bg-[#F74417] text-white rounded-full p-1 min-w-[14px] h-[14px] flex items-center justify-center">{{
                      unreadCountByCategory("aftersale") > 99
                        ? 99
                        : unreadCountByCategory("aftersale")
                    }}</span>
                </li>
                <li class="px-2.5 py-2 flex items-center justify-between cursor-pointer" :class="primaryCategory === 'report'
                  ? 'text-[#000] font-bold bg-[#F3F4F9]'
                  : ''
                  " @click="choosePrimary('report')">
                  <span class="text-sm">举报</span>
                  <span v-if="unreadCountByCategory('report') > 0"
                    class="text-[10px] bg-[#F74417] text-white rounded-full p-1 min-w-[14px] h-[14px] flex items-center justify-center">{{
                      unreadCountByCategory("report") > 99
                        ? 99
                        : unreadCountByCategory("report")
                    }}</span>
                </li>
              </ul>
            </div>
            <div v-if="secondaryVisible"
              class="flex-1 p-5 ml-0.5 bg-white rounded-lg shadow-[0_0_20px_0_rgba(168,168,168,0.25)]">
              <div class="flex items-center space-x-5">
                <button class="text-sm px-2.5 py-1" :class="activeSecondary === 'all'
                  ? 'text-[#47496F] font-bold bg-[#F3F4F9] rounded-lg'
                  : 'text-[#737380]'
                  " @click="activeSecondary = 'all'">
                  全部消息
                </button>
                <button class="text-sm px-2.5 py-1" :class="activeSecondary === 'comment'
                  ? 'text-[#47496F] font-bold bg-[#F3F4F9] rounded-lg'
                  : 'text-[#737380]'
                  " @click="activeSecondary = 'comment'">
                  评论
                </button>
                <button class="text-sm px-2.5 py-1" :class="activeSecondary === 'reply'
                  ? 'text-[#47496F] font-bold bg-[#F3F4F9] rounded-lg'
                  : 'text-[#737380]'
                  " @click="activeSecondary = 'reply'">
                  回复
                </button>
                <button class="text-sm px-2.5 py-1" :class="activeSecondary === 'like'
                  ? 'text-[#47496F] font-bold bg-[#F3F4F9] rounded-lg'
                  : 'text-[#737380]'
                  " @click="activeSecondary = 'like'">
                  点赞
                </button>
                <button class="text-sm px-2.5 py-1" :class="activeSecondary === 'favorite'
                  ? 'text-[#47496F] font-bold bg-[#F3F4F9] rounded-lg'
                  : 'text-[#737380]'
                  " @click="activeSecondary = 'favorite'">
                  收藏
                </button>
                <!-- <div class="flex-1"></div>
                <div class="text-[#737380] text-xs">{{ unreadCount }} 条未读</div>
                <button class="text-xs text-[#47496F]" @click="markAllVisibleUnread">标记已读</button> -->
              </div>
              <div class="max-h-[360px] overflow-y-auto space-y-2">
                <div @click="goDetail(item)" v-for="item in visibleList" :key="item.id"
                  class="flex py-5 rounded hover:bg-[#F3F4F9] cursor-pointer">
                  <div class="relative mr-5 w-10 h-10 shrink-0">
                    <img :src="item.senderAvatar || defaultAvatar"
                      class="w-full h-full rounded-full border border-[#D9D9D9]" />
                    <div v-if="item.isRead === 0" class="absolute -top-0.5 -right-0.5 w-3 h-3 bg-[#F74417] rounded-full border-[1.5px] border-white"></div>
                  </div>
                  <div class="flex-1 gap-5">
                    <div class="text-sm flex flex-col gap-2.5">
                      <div class="font-bold">{{ item.senderName }}</div>
                      <div>{{ excerpt(item.content) }}</div>
                      <div class="flex gap-2.5 text-[#737380]">
                        <span v-if="item.remark">{{ item.remark }}</span>
                        {{ formatTime(item.createTime) }}
                      </div>
                    </div>
                  </div>
                  <img class="w-[60px] h-[60px] rounded-lg" :src="item.prodImg" alt="" />
                </div>
                <div v-if="notificationLoading" class="text-center py-2 text-xs text-[#737380]">
                  加载中...
                </div>
                <div v-if="!notificationLoading && visibleList.length === 0"
                  class="text-center py-6 text-xs text-[#222226]">
                  暂无数据
                </div>
              </div>
              <!-- <div class="flex justify-end items-center space-x-2 mt-3">
                <button
                  class="px-2 py-1 border rounded text-xs"
                  :disabled="pageNum <= 1"
                  @click="changePage(pageNum - 1)"
                >
                  上一页
                </button>
                <button
                  class="px-2 py-1 border rounded text-xs"
                  :disabled="pageNum >= maxPage"
                  @click="changePage(pageNum + 1)"
                >
                  下一页
                </button>
              </div> -->
            </div>
            <!-- 售后列表 - 绝对定位在售后右侧 -->
            <div v-if="aftersaleVisible && primaryCategory === 'aftersale'"
              class="flex-1 p-5 ml-0.5 mt-10 bg-white rounded-lg shadow-[0_0_20px_0_rgba(168,168,168,0.25)]">
              <div class="max-h-[360px] overflow-y-auto space-y-5 pt-1.5 pr-1.5">
                <div @click="goAftersaleDetail(item)" v-for="item in visibleList" :key="item.id"
                  class="flex gap-5 hover:bg-[#F3F4F9] cursor-pointer">
                  <div class="relative shrink-0 w-[60px] h-[60px]">
                    <img :src="item.prodImg" class="w-full h-full rounded-lg" />
                    <div v-if="item.isRead === 0" class="absolute -top-1 -right-1 w-3 h-3 bg-[#F74417] rounded-full border-[1.5px] border-white"></div>
                  </div>
                  <div class="flex-1">
                    <div class="text-sm flex flex-col gap-2.5">
                      <div class="text-sm text-[#737380]">
                        {{ item.prodName }}
                      </div>
                      <div class="text-[#F74417]">客服：{{ excerpt(item.content) }}</div>
                      <div class="text-[#F74417] text-sm">
                        {{ excerpt(item.remark) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="notificationLoading" class="text-center py-2 text-xs text-[#737380]">
                  加载中...
                </div>
                <div v-if="!notificationLoading && visibleList.length === 0"
                  class="text-center py-4 text-xs text-[#737380]">
                  暂无售后消息
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h-8 my-1 flex justify-between items-center space-x-2.5 media">
        <div v-v31-hide>
          <StandardInputSelect class="w-20 country" style="height: 100%; background: none" v-model="language">
            <div v-for="item in languageList" :key="item.img">
              <img class="h-5" :src="item.img" />
            </div>
          </StandardInputSelect>
        </div>
        <StandardButton v-if="!isLogin" @click="loginShow = true"
          class="bg-black-2 text-white tracking-widest min-w-[120px] text-sm">登录账户
        </StandardButton>
        <StandardButton class="bg-black-2 text-white relative tracking-widest min-w-[120px] text-sm" id="showPersonal"
          @mouseenter="isPersonalDropdown = true" @mouseleave="isPersonalDropdown = false" @click="goPersonal" v-else>
          <div class="nickname-tooltip-trigger relative w-full mx-auto max-w-[5em]">
            <div class="text-ellipsis overflow-hidden whitespace-nowrap" style="letter-spacing: 0px">
              {{ userName || "个人中心" }}
            </div>
            <span v-if="userName" class="nickname-tooltip">{{ userName }}</span>
          </div>
          <div v-show="isPersonalDropdown" style="z-index: 11" class="absolute top-8 left-0 w-full">
            <div class="h-4 bg-transparent"></div>
            <ul class="text-black leading-6 w-full bg-[#F3F4F9] rounded border-[#F3F4F9] text-[#222226]">
              <li class="leading-8 hover:bg-black-1 hover:text-white tracking-widest rounded-t"
                @click.stop="goPersonalCenter">
                个人页面
              </li>
              <hr />
              <li class="leading-8 hover:bg-black-1 hover:text-white tracking-widest rounded-b" @click.stop="exit">
                退出
              </li>
            </ul>
          </div>
        </StandardButton>
        <StandardButton class="bg-black-2 text-white tracking-widest min-w-[120px] text-sm" @click="goOrder">历史记录
        </StandardButton>
      </div>
    </div>
  </div>
  <!-- 地址选择弹窗 -->
  <AddressDialog :addressShow="addressShow" :addressList="addressList" :selectedAddress="selectedAddress"
    @close="addressShow = false" @addrChange="onAddrChange" />
  <LoginDialog v-model:visibility="loginShow" :mode="loginMode"> </LoginDialog>
</template>

<script setup>
import {
  ref,
  reactive,
  watch,
  computed,
  provide,
  onMounted,
  onUnmounted,
  watchEffect,
  onBeforeMount,
} from "vue";
import { defHttp, noTokenHttp } from "@utils/http";
import {
  calculateDeliveryTime,
  formatDeliveryDate,
} from "@/utils/deliveryTime";

import {
  Dialog,
  DialogOverlay,
  Switch,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";

import { ElMessage } from "element-plus";

import { useRoute, useRouter } from "vue-router";
import i18nIcon from "@icons/i18n";
import LoginDialog from "@components/LoginDialog.vue";
import StandardButton from "@components/StandardButton.vue";
import StandardInputSelect from "@components/StandardInputSelect.vue";
import StandardInput from "@components/StandardInput.vue";
import StandardInputNumber from "@components/StandardInputNumber.vue";
import Bus from "@utils/bus.js";
import modelManager from "@/utils/modelManager";
import AddressDialog from "@components/App/AddressDialog.vue";
import { notification, message } from "@/utils/notification";
import { useNotificationStore } from "@/store/notificationStore/index.js";
import {
  clearStoragePreservingRememberedLogin,
  isLoggedIn,
} from "@utils/user";

import AddressTagIcon from "./AddressTagIcon.vue";

// 引入购物车store
import useStore from "@store";
import { storeToRefs } from "pinia";

const { shopStore, orderListStore } = useStore();
const {
  apiHadrDiskSize,
  localHadrDiskSize,
  hardDiskSize,
  shoppingCartList,
  shoppingCartListTotal,
  isLoading,
} = storeToRefs(shopStore); //将num转为响应式
// 展示个人中心下拉
let isPersonalDropdown = ref(false);

// 站内信
const notificationStore = useNotificationStore();
const isNotificationDropdown = ref(false);
const secondaryVisible = ref(false);
const aftersaleVisible = ref(false);
const primaryCategory = ref("");
const activeSecondary = ref("all");
const defaultAvatar = new URL(
  "../../assets/images/headerImg02.png",
  import.meta.url,
).href;
const notificationLoading = computed(() => notificationStore.loading);
const unreadCount = computed(() => notificationStore.unreadCount);
console.log("unreadCount:", unreadCount);
const visibleList = computed(() => {
  const list = notificationStore.list || [];

  if (primaryCategory.value === "comment") {
    // 评论一级菜单：包含评论、回复、点赞、收藏
    const commentRelatedTypes = ["comment", "reply", "like", "favorite"];
    const commentList = list.filter((item) =>
      commentRelatedTypes.includes((item.typeCode || "").toLowerCase()),
    );

    if (activeSecondary.value === "all") {
      return commentList; // 全部信息：显示评论、回复、点赞、收藏
    } else {
      return commentList.filter(
        (item) => (item.typeCode || "").toLowerCase() === activeSecondary.value,
      );
    }
  } else if (primaryCategory.value === "aftersale") {
    // 售后一级菜单：只显示售后类型
    return list.filter(
      (item) => (item.typeCode || "").toLowerCase() === "aftersale",
    );
  } else if (primaryCategory.value === "report") {
    // 举报一级菜单：只显示举报类型
    return list.filter(
      (item) => (item.typeCode || "").toLowerCase() === "report",
    );
  }

  return list;
});

function toggleNotifications() {
  if (!isLogin.value) {
    loginShow.value = true;
    return;
  }

  // 切换消息框显示状态
  isNotificationDropdown.value = !isNotificationDropdown.value;

  if (isNotificationDropdown.value) {
    secondaryVisible.value = false;
    // 显示时添加全局点击监听
    setTimeout(() => {
      document.addEventListener("click", handleGlobalClick);
    }, 0);

    // 加载消息数据
    if (!notificationStore.list || notificationStore.list.length === 0) {
      notificationStore.fetchPage({
        unreadOnly: false,
        pageNum: 1,
        pageSize: 10,
      });
    }
  } else {
    document.removeEventListener("click", handleGlobalClick);
  }
}

function closeNotificationDropdown() {
  isNotificationDropdown.value = false;
  secondaryVisible.value = false;
  aftersaleVisible.value = false;
}

async function refreshNotificationsAfterRead() {
  await notificationStore.getConfig();
  await notificationStore.fetchList();
}

async function goAftersaleDetail(item) {
  await markAsRead(item.id);

  const orderNumber = item.orderNumber;
  if (!orderNumber) {
    ElMessage.warning("未找到售后订单编号");
    await refreshNotificationsAfterRead();
    return;
  }

  const locateQuery = new URLSearchParams({
    orderNumber,
    pageSize: "10",
  });
  const notificationAfterSaleId = item.afterSaleId ?? item.bizId;
  if (notificationAfterSaleId) {
    locateQuery.set("afterSaleId", String(notificationAfterSaleId));
  }
  const res = await defHttp.get(
    `/api/user-api/afterSale/locate?${locateQuery.toString()}`,
  );
  const data = res?.data?.data || {};

  if (res?.data?.code !== 200) {
    ElMessage.warning(res?.data?.msg || "售后定位失败");
    await refreshNotificationsAfterRead();
    return;
  }

  if (!data.exists || !data.pageNum) {
    ElMessage.warning("未找到对应售后订单");
    await refreshNotificationsAfterRead();
    return;
  }

  closeNotificationDropdown();
  router.push({
    path: "/sell",
    query: {
      pageNum: String(data.pageNum),
      openAfterSale: "1",
      orderNumber,
      afterSaleId: data.afterSaleId ? String(data.afterSaleId) : "",
    },
  });
  await refreshNotificationsAfterRead();
}

async function goDetail(item) {
  await markAsRead(item.id);

  const prodId = item.prodId;
  const commentId = item.bizId;
  if (!prodId || !commentId) {
    ElMessage.warning("未找到评论跳转信息");
    await refreshNotificationsAfterRead();
    return;
  }

  closeNotificationDropdown();
  router.push({
    name: "Goods",
    params: { id: prodId },
    query: {
      isComment: 1,
      noticeCommentId: commentId,
    },
  });
  await refreshNotificationsAfterRead();
}



async function markAsRead(id) {
  // 标记已读
  await defHttp.get("/api/notify/read?msgId=" + id);
}

// 轮询相关配置
const pollInterval = ref(30000); // 轮询间隔，默认30秒（可根据需求调整）
let notificationPollTimer = null; // 定时器引用，用于清除轮询
const isPolling = ref(false); // 标记是否正在轮询

// 站内信轮询函数
async function pollNotifications() {
  // 未登录时停止轮询
  if (!isLogin.value) {
    stopNotificationPoll();
    return;
  }

  try {
    // 执行轮询请求
    await notificationStore.getConfig();
    await notificationStore.fetchList();
  } catch (error) {
    console.error("站内信轮询请求失败:", error);
  }
}

// 启动轮询
function startNotificationPoll() {
  // 避免重复启动
  if (isPolling.value || !isLogin.value) return;

  isPolling.value = true;
  // 立即执行一次，然后开始定时轮询
  pollNotifications();
  notificationPollTimer = setInterval(pollNotifications, pollInterval.value);
}

// 停止轮询
function stopNotificationPoll() {
  if (notificationPollTimer) {
    clearInterval(notificationPollTimer);
    notificationPollTimer = null;
  }
  isPolling.value = false;
}



function excerpt(htmlOrText) {
  const s = String(htmlOrText || "").replace(/<[^>]+>/g, "");
  return s.length > 40 ? s.slice(0, 40) + "…" : s;
}

function formatTime(t) {
  try {
    if (!t) return "";

    const match = t.match(/(\w{3}) (\w{3}) (\d{2}) \d{2}:\d{2}:\d{2} \w+ (\d{4})/);
    if (match) {
      const monthMap = {
        Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
        Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
      };
      const year = match[4];
      const month = monthMap[match[2]];
      const day = match[3];
      return `${year}-${month}-${day}`;
    }

    // 兼容其他正常时间格式
    const d = new Date(t);
    if (isNaN(d.getTime())) return t || "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch (e) {
    return t || "";
  }
}

function unreadCountByCategory(cat) {
  const countByType = notificationStore.unreadCountByType || {};
  if (cat === "comment") {
    return ["comment", "like", "favorite", "reply"].reduce(
      (sum, type) => sum + (Number(countByType[type]) || 0),
      0,
    );
  }
  return Number(countByType[cat]) || 0;
}

function choosePrimary(cat) {
  primaryCategory.value = cat;
  activeSecondary.value = "all";

  if (cat === "report") {
    // 点击举报，直接跳转到账户管理的举报投诉页面
    router.push({
      name: "Personal",
      query: { linkChild: "complaint" },
    });
    // 关闭通知下拉菜单
    isNotificationDropdown.value = false;
    secondaryVisible.value = false;
    aftersaleVisible.value = false;
  } else if (cat === "aftersale") {
    secondaryVisible.value = false;
    aftersaleVisible.value = true;
  } else {
    // 评论：显示二级菜单
    secondaryVisible.value = true;
    aftersaleVisible.value = false;
  }
}

const headerImgs = reactive([
  {
    id: 1,
    src: "https://test.widofactory.com/image/1de44cf953f44b1d9c5fc2fc23ee9281.png",
    signSrc:
      "https://test.widofactory.com/image/de5d8c0b51204a22a427f169f933bf6b.png",
  },
  {
    id: 2,
    src: new URL("../../assets/images/headerImg02.png", import.meta.url).href,
    signSrc: new URL("../../assets/images/headerImg002.png", import.meta.url)
      .href,
  },
  {
    id: 3,
    src: new URL("../../assets/images/headerImg03.png", import.meta.url).href,
    signSrc: new URL("../../assets/images/headerImg003.png", import.meta.url)
      .href,
  },
  {
    id: 4,
    src: new URL("../../assets/images/headerImg04.png", import.meta.url).href,
    signSrc: new URL("../../assets/images/headerImg004.png", import.meta.url)
      .href,
  },
  {
    id: 5,
    src: new URL("../../assets/images/headerImg05.png", import.meta.url).href,
    signSrc: new URL("../../assets/images/headerImg005.png", import.meta.url)
      .href,
  },
]);
let headerSign = ref(1);
const mouseFlag = ref(false);
// 退出登录
function exit() {
  console.log("88484");
  clearStoragePreservingRememberedLogin();
  window.dispatchEvent(new Event("clearStorageEvent"));

  const bc = new BroadcastChannel("clear-storage-channel");
  bc.postMessage("clear"); // 发送消息

  setTimeout(() => {
    // router.push({name:'HomeShop'})
    location.reload();
  }, 1000);
}

function addDay(dayNumber, date) {
  date = date ? date : new Date();
  var ms = dayNumber * (1000 * 60 * 60 * 24);
  var newDate = new Date(date.getTime() + ms);
  return newDate.getMonth() + 1 + "-" + newDate.getDate();
}
const expectedDate = addDay(4);

// banner 相关逻辑
// let screenHeight = document.documentElement.offsetHeight
// let headerHeight = parseInt(screenHeight * 85 / 100)
// localStorage.setItem('bannerHeight', headerHeight)

// if (localStorage.getItem('banner') != new Date().getDate()) {
//     localStorage.setItem('banner', new Date().getDate())
//     setTimeout(() => {
//         window.scroll({ top: headerHeight, behavior: 'smooth' })
//         setTimeout(() => {
//             console.log(`banner高度${headerHeight}，滚动高度-${document.documentElement.scrollTop}`)
//         }, 0)
//     }, 3000)
// } else {
//     document.addEventListener('DOMContentLoaded', function () {
//         console.log('window.onlodd--banner', headerHeight)
//         setTimeout(() => {
//             window.scroll({ top: headerHeight })
//             // window.scroll({ top: 1928})
//             console.log(`banner高度${headerHeight}，滚动高度-${document.documentElement.scrollTop}`)
//         }, 0)

//     });
// }

/*

*/
const searchStr = ref("");

//i18n
const language = ref(0);
const languageList = Object.keys(i18nIcon).map((key) => {
  return { img: i18nIcon[key] };
});

function goOrder() {
  if (!isLogin.value) {
    loginShow.value = true;
  } else {
    router.push({ path: "/sell" });
  }
}

function goPersonal() {
  router.push({ path: "/personal", params: {} });
}

function goPersonalCenter() {
  router.push({ path: "/personalCenter", params: {} });
}
function goConfirmOrder() {
  if (!isLogin.value) {
    loginShow.value = true;
  } else {
    router.push({ name: "ConfirmOrder", params: {} });
  }
}

function countLocalModels() {
  return new Promise((resolve) => {
    modelManager.countModels((num) => resolve(num));
  });
}

function addLocalModel(model) {
  return new Promise((resolve) => {
    modelManager.addModel(model, resolve);
  });
}

const PENDING_CUSTOM_CART_RESTORE_KEY = "wido_pending_custom_cart_restore";

function unwrapCartCount(value) {
  const rawValue = value?.value?.value ?? value?.value ?? value;
  const count = Number(rawValue);
  return Number.isFinite(count) && count > 0 ? count : null;
}

function getSkuCount(sku) {
  return (
    unwrapCartCount(sku?.skuCount) ||
    unwrapCartCount(sku?.number) ||
    unwrapCartCount(sku?.basketCount) ||
    unwrapCartCount(sku?.count)
  );
}

function buildLocalModelFromCartSku(sku, basketCount) {
  const count = getSkuCount(sku) || unwrapCartCount(basketCount) || 1;
  return {
    file: {
      url: sku.modelUrl,
      id: sku.modelId,
      size: sku.modelSize,
    },
    img: sku.skuPic,
    price: Number(
      sku.skuTotalPrice ?? Number(sku.skuPrice) * count,
    ),
    name: sku.skuName,
    num: count,
    props: sku.props.split(",").map(Number),
    printType: sku.skuType,
    printingModeId: sku.printingModeId,
  };
}

async function restoreCustomCartModels(items = [], basketCount) {
  for (const sku of items) {
    const model = buildLocalModelFromCartSku(sku, basketCount);
    await addLocalModel(model);
  }
}

// 点击打印列表里的商品图片：跳转到商品详情或自定义打印界面
// 与结算页(ConfirmOrder)的「修改」逻辑保持一致
async function goProductDetail(item) {
  if (item.state == 0) {
    // 自定义打印：回填模型到主页编辑
    const num = await countLocalModels();
    if (num > 0) {
      message("主页有未保存数据，请先保存", () => {
        router.push("/home");
      });
      return;
    }

    sessionStorage.setItem(
      PENDING_CUSTOM_CART_RESTORE_KEY,
      JSON.stringify({
        basketId: item.id,
        models: (item.items || []).map((sku) => buildLocalModelFromCartSku(sku, item.num)),
      }),
    );

    if (route.name !== "Home") {
      router.push("/home");
      return;
    }

    Bus.$emit("restore_custom_cart_models");
  } else {
    // 普通商品：跳转到商品详情（编辑态）
    router.push({
      path: `/goods/${item.prodId}`,
      query: {
        isEdit: true,
        id: item.prodId,
        basketId: item.id,
      },
    });
  }
}



// 去搜索
function goSearchPage() {
  console.log("searchStr", searchStr.value);
  if (!searchStr.value.trim()) {
    ElMessage.warning("请输入搜索内容");
    return false;
  }
  router.push({
    name: "SearchResult",
    params: { str: searchStr.value, id: isNaN(goodType) ? -1 : goodType },
    query: {
      label: goodTypeList.find((item) => item.value == goodType)?.label,
    },
  });
}

/*
购物车相关逻辑
*/

const shoppingCartShow = ref(false);

Bus.$on("changeshoppingCartShow", (bol) => {
  loginShow.value = bol;
});

/*
编辑右侧购物车商品数量
*/
async function updateNumChange(valueObj) {
  console.log("购物车数量改变", valueObj);
  let params = {
    basketId: valueObj.item.id,
    basketCount: valueObj.value,
  };
  await defHttp.post("/api/user-api/basket/edit", params);
  await shopStore.getShoppingList();
  shopStore.getHardDiskSize();
}

const router = useRouter();
const route = useRoute();

const userName = ref(localStorage.getItem("username") || "");
const isLogin = ref(isLoggedIn());

function resetLoggedOutHeaderState() {
  userName.value = "";
  addressShow.value = false;
  isPersonalDropdown.value = false;
  closeNotificationDropdown();
  stopNotificationPoll();
  notificationStore.$reset();
  shopStore.clearShoppingState();
}

function syncAuthState() {
  isLogin.value = isLoggedIn();
  userName.value = localStorage.getItem("username") || "";
  if (!isLogin.value) {
    resetLoggedOutHeaderState();
  }
}

Bus.$on("goPersonal", () => {
  userName.value = localStorage.getItem("username");
});

const loginShow = ref(false);
Bus.$on("changeLoginShow", (bol) => {
  loginShow.value = bol;
});
// console.log({ loginShow }, '😡project')
const loginMode = ref(0);

function logout() {
  console.log("88483");
  defHttp.post("/api/logout").then(() => {
    console.log("88484");
    clearStoragePreservingRememberedLogin();
    window.dispatchEvent(new Event("clearStorageEvent"));
    location.reload();
  });
}

router.beforeEach((to, from, next) => {
  console.log(from, "from");
  if (
    from.name == "Receipt" ||
    from.name == "OrderDetails" ||
    from.path == "/sell"
  ) {
    console.log("O&R");
  } else {
    orderListStore.reset();
  }
  next();
});

onMounted(() => {
  if (route.name == "Home") {
    headerImgFlag.value = false;
  } else {
    ynHeaderImgFlag.value = false;
    headerImgFlag.value = true;
  }
  if (
    shoppingCartList.value.length > 0 &&
    !(route.name == "ConfirmOrder" || route.name == "ShoppingCart")
  ) {
    shoppingCartShow.value = true;
  } else {
    shoppingCartShow.value = false;
  }
  Bus.$on("scrollChange", handleScroll);

  Bus.$on("updateAddress", getAddress);
  Bus.$on("searchStr", (val) => {
    searchStr.value = val;
    goSearchPage();
  });
  if (isLogin.value) {
    startNotificationPoll();
    getAddress();
  }
  Bus.$on("authStateChanged", syncAuthState);
});
// 组件卸载时移除监听
onUnmounted(() => {
  Bus.$off("scrollChange", handleScroll);
  Bus.$off("updateAddress", getAddress);
  Bus.$off("searchStr", (val) => {
    searchStr.value = val;
    goSearchPage();
  });
  document.removeEventListener("click", handleGlobalClick);
  Bus.$off("authStateChanged", syncAuthState);
  // 组件卸载时停止轮询
  stopNotificationPoll();
});
const headerImgFlag = ref(true);
const ynHeaderImgFlag = ref(false);
// 计算属性：根据localHadrDiskSize和mouseFlag决定显示哪个图片
const currentHeaderImg = computed(() => {
  const currentImg = headerImgs.find((item) => item.id == headerSign.value);
  if (!currentImg) return "";

  // 如果有本地硬盘容量，显示src；如果容量为0，根据mouseFlag决定显示哪个图片
  return localHadrDiskSize.value !== 0
    ? currentImg.src
    : !mouseFlag.value
      ? currentImg.signSrc
      : currentImg.src;
});

watch(localHadrDiskSize, (newVal) => {
  if (newVal === 0) {
    mouseFlag.value = false;
  }
});

watch(route, async (route) => {
  // 右侧购物车只在首页和商品详情页和历史记录 购物车有数据得时候自动展示，不能隐藏
  if (
    shoppingCartList.value.length > 0 &&
    !(route.name == "ConfirmOrder" || route.name == "ShoppingCart")
  ) {
    shoppingCartShow.value = true;
    console.log("1555599");
  } else {
    shoppingCartShow.value = false;
    console.log("789789", shoppingCartList.value);
  }
  if (route.name == "Home") {
    headerImgFlag.value = false;
  } else {
    ynHeaderImgFlag.value = false;
    headerImgFlag.value = true;
  }

  // 当前路由不是搜索页面 清空搜索框
  if (route.name != "SearchResult") {
    searchStr.value = "";
  }
});

// 购物车数据变更时 判断右侧购物车是否展示隐藏
watch(shoppingCartList.value, (shoppingCartList, old) => {
  if (shoppingCartList.length > 0) {
    if (route.name == "ConfirmOrder" || route.name == "ShoppingCart") {
      shoppingCartShow.value = false;
      ynanmite.value = false;
    } else {
      shoppingCartShow.value = true;
      ynanmite.value = true;
      // console.log("显示打印列表")
    }
  } else {
    shoppingCartShow.value = false;
    ynanmite.value = false;
  }
});

// 监听登录状态变化，动态启停轮询
watch(
  () => isLogin.value,
  (newVal) => {
    if (newVal) {
      startNotificationPoll(); // 登录后启动轮询
    } else {
      stopNotificationPoll(); // 登出后停止轮询
    }
  },
  { immediate: true },
);

async function delGood(good) {
  if (good.parent) {
    let parent = good.parent;
    if (parent.children.length == 1) {
      await defHttp.post("/api/user-api/basket/delete", { id: parent.id });
    } else {
      await defHttp.post("/api/user-api/basket/item/delete", {
        basketId: parent.id,
        skuId: good.id,
      });
    }
  } else {
    await defHttp.post("/api/user-api/basket/delete", { id: good.id });
  }
  await shopStore.getShoppingList();
  shopStore.getHardDiskSize();
  // Bus.$emit('shoppingListChanged');
}

//获取商品分类
const goodTypeList = reactive([]);
const goodType = ref(null);
noTokenHttp.post("/api/user-api/category/list", {}).then(function (res) {
  const data = res.data.data;
  goodTypeList.push({ label: "所有", value: "0" });
  data.forEach((item) => {
    // TODO: item.categoryId 接口返回null
    goodTypeList.push({ label: item.name, value: item.categoryId || -1 });
  });
  // provide("goodTypeList", goodTypeList);
});

/*
地址相关
*/

const addressShow = ref(false);
const addressList = ref([]);
const selectedAddress = ref({});

function onAddrChange(addr) {
  selectedAddress.value = addr;
  console.log("selectedAddress.value", selectedAddress.value);
  addressShow.value = false;
  // 设置为默认地址
  defHttp.post("/api/user-api/user/update", { addressId: addr.id }).then(() => {
    Bus.$emit("updateAddress"); // 通知全局刷新
  });
}

function getAddress() {
  defHttp.post("/api/user-api/address/list", {}).then(function (res) {
    if (res.data.code === 200) {
      const data = res.data.rows;
      addressList.value = data.map((item) => ({
        id: item.addressId,
        name: item.name,
        phone: item.phone,
        area: item.addressDict,
        address:
          (item.province ? item.province : "") +
          (item.city ? item.city : "") +
          (item.area ? item.area : "") +
          item.detailedInfo,
        tagVal: item.tagVal,
        isDefault: item.isDefault,
        postCode: item.postCode,
      }));
      // 默认空白邮寄地址
      const def = addressList.value.find((a) => a.isDefault);
      if (def) {
        selectedAddress.value = def;
      } else {
        console.log("默认地址");
        selectedAddress.value = { name: "", tagVal: "" };
      }
    }
  });
}

const styleHeightObj = ref({ height: 0 });

let isScrolling = false;
let lastScrollTime = 0;
let scrollTriggerCount = 0;
let shouldExecuteXXX = false;
let ynanmite = ref(false); //当需要滚动后变化

// 头部动画＋购物车
function handleScroll(scrollData) {
  const { scrollTop } = scrollData || {};
  // console.log("接收到的滚动数据:",scrollTop); // 调试用 todo
  const currentTime = new Date().getTime();

  if (scrollTop > 40) {
    styleHeightObj.value = { height: 0 };
    if (shoppingCartList.value.length > 0) {
      ynanmite.value = true;
    } else {
      ynanmite.value = false;
    }
    ynHeaderImgFlag.value = true;
  } else {
    // console.log("false",ynHeaderImgFlag.value)
    ynHeaderImgFlag.value = false;
  }

  isScrolling = false;
  lastScrollTime = currentTime;
}

window.addEventListener("wheel", function (event) {
  // console.log("滚动事件触发", event.deltaY); // 调试用
  const currentTime = new Date().getTime();
  if (!isScrolling && currentTime - lastScrollTime > 300) {
    isScrolling = true;
    requestAnimationFrame(() => handleScroll(event));
    if (shouldExecuteXXX) {
      scrollTriggerCount = 0; // Reset count after executing xxx()
      styleHeightObj.value = { height: "360px" };
      shouldExecuteXXX = false;
    }
  }
  if (
    styleHeightObj.value.height == 0 &&
    shoppingCartList.value.length > 0 &&
    route.path !== "/confirmorder"
  ) {
    ynanmite.value = true;
  } else {
    ynanmite.value = false;
  }
});

// 消息框
const handleGlobalClick = () => {
  if (isNotificationDropdown.value) {
    isNotificationDropdown.value = false;
    secondaryVisible.value = false;
    aftersaleVisible.value = false;
  }
};
</script>

<style scoped lang="scss">
@import url(../../assets/css/media.css);

.nickname-tooltip {
  display: none;
  position: absolute;
  top: 50%;
  right: calc(100% + 10px);
  transform: translateY(-50%);
  z-index: 20;
  padding: 4px 6px;
  border-radius: 3px;
  background: #fff;
  color: #222226;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  white-space: nowrap;
  pointer-events: none;
}

.nickname-tooltip-trigger:hover .nickname-tooltip {
  display: block;
}

.header-imgs {
  overflow: hidden;
  transition: all 0.2s linear;
}

.header .yesanmite {
  position: fixed;
  right: 8px;
  top: 0;
  z-index: 20;
  width: 140px;
  height: 60px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  margin: 0;
}

.header .noanmite {
  position: absolute;
  top: 0px;
  right: 10px;
  z-index: 20;
}

.searchInput {
  min-width: 430px;
  font-size: 16px;
}

// 实现头部的展示与隐藏效果
.h360 {
  height: 360px;
  transition: all 2s linear;
}

.hChange {
  height: 0;
}

.container2 {
  transition: all 2s linear;
}

.hChange2 {
  transform: translateY(-360px);
}

:deep(.hideScrollbar button) {
  border: none;
  background: rgb(215, 200, 243);
}

.hideScrollbar::-webkit-scrollbar,
.hideScrollbar>div>ul::-webkit-scrollbar,
.shoppingCartList::-webkit-scrollbar {
  width: 1px !important;
}

:deep(.country button.bg-white) {
  border: none;
  background: none;
}

:deep(.country ul) {
  border: none;
}

:deep(.country li) {
  border: solid 2px #401895;
  border-top: none;
}

.shoppingCartList {
  overscroll-behavior-y: none;
}

.compDesc {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: center;
}

.address-maxwidth {
  max-width: 80px;
}

.custom-entry-img {
  z-index: 20;
  transition: all 0.3s ease;
}

.fixed-position {
  position: fixed;
  top: 5px; // 与购物车对齐
  left: 0;
}
</style>
